import React from "react"
import { connect } from "react-redux"
import { Container, Row, Col } from "reactstrap"

const TalentSpotlight = ({ spotlight = [] }) => {
  console.log(spotlight)

  return (
    <Container fluid id="talentSpotlight">
      <Row className="title-row">
        <Col>
          <h1>SPOTLIGHT : SEASON 2</h1>
          <h1>
            Minority owned brands, creatives of color, and unheard voices who
            inspire us on a daily basis. This space will rotate seasonally, send
            us feature recommendations in our contact form below.
          </h1>
        </Col>
      </Row>
      <Row className="spotlight-row">
        {spotlight &&
          spotlight
            .slice(Math.max(spotlight.length - 4, 0))
            .reverse()
            .map((i, idx) => {
              return (
                <Col key={idx} className="spotlight-item" xs="6" md="3">
                  <a
                    href={i.instagramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div
                      className="talent-image"
                      style={{
                        background: `url(${i.coverImage.file.url})`,
                        backgroundPosition: `center`,
                        backgroundSize: `cover`,
                      }}
                    ></div>
                    <div className="hover-container">
                      <div className="inner-container">
                        <span>{i.displayName}</span>
                      </div>
                    </div>
                  </a>
                </Col>
              )
            })}
        <Col></Col>
      </Row>
    </Container>
  )
}

export default connect(
  state => ({
    mobile: state.global.mobile,
  }),
  null
)(TalentSpotlight)
